<template>
 <section>
        <!-- 查询栏 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
         <span style="float: left;">统计客户的年龄段分布,以及性别数量</span>         
			<el-form :inline="true" :model="filters" style="float: right;">
				<!-- <el-form-item>
					<el-input v-model="filters.shopname" placeholder="门店名称"></el-input>
				</el-form-item> -->
				<el-form-item v-if="TenancyId=='0'||TenancyId==null">
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				
                   </el-form-item>   

                <el-form-item v-if="TenancyId=='0'||TenancyId==null">
                    <div class="block">
                   <el-date-picker
                        v-model="dateValue"
                         type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                   </el-date-picker>
                    </div>
                   </el-form-item>
                   <!-- <el-form-item>
                <el-select v-model="stateValue" placeholder  placeholder="请选状态" style="width:192px">
                <el-option
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                </el-option>
                 </el-select>
                 </el-form-item> -->
				<el-form-item>
					<el-button type="primary" v-on:click="GetBusinessData" icon="el-icon-search">查询统计</el-button>
				</el-form-item>		
			</el-form>
		</el-col>
        	<!--列表-->
		<el-table :data="businessDataList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column prop="CardType" label="业务类型 " width="150"  :formatter="formatType" sortable>
			</el-table-column> -->
			<el-table-column prop="Serial" label="年龄段" width="120" sortable>
			</el-table-column>
 			<el-table-column prop="Cnt" label="人数" width="120" sortable>
			</el-table-column>    
  			<el-table-column prop="Sex" label="性别" width="120" :formatter="formatSex" sortable>
			</el-table-column>                    
            <el-table-column label="操作" min-width="120" >
				<template  slot-scope="scope">
					<el-button  type="primary" size="small" @click="detail(scope.$index, scope.row)">查看会员明细</el-button>
				</template>
			</el-table-column>
		</el-table>
        <!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
        	<el-tag>共有{{total}}条统计记录</el-tag>
		</el-col>

        <el-dialog  v-model="dialogTableVisible" >
           <el-table :data="businessDataDetail" highlight-current-row v-loading="logLoading" max-height="500">	
			<el-table-column prop="CardNumber" label="会员卡号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="会员名称" width="120" sortable>
			</el-table-column>				
			<el-table-column prop="Telephone" label="联系电话" width="130" sortable>
			</el-table-column>	
			<el-table-column prop="ComboName" label="套餐名称" width="180" sortable>
			</el-table-column>            		
			<el-table-column prop="CreationTime" label="开卡时间" width="180" :formatter="formatDate" sortable>
			</el-table-column>          
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
           </el-table>
		   	<el-col :span="24" class="toolbar">
			<el-tag>共有{{logCount}}条记录</el-tag>
			<!-- <el-pagination layout="prev, pager, next" @current-change="CurrentChange" :page-size="10" :total="logCount" style="float:right;">
			</el-pagination> -->
	     	</el-col>
        </el-dialog>
    </section>
</template>
<script>
import {GetCustomerTypeReport,GetCustomerDetail,getShopInfor} from '../../../api/api';
import util from '../../../common/js/util'
import {mapGetters} from 'vuex';
export default {
     data() {
    return {
       TenancyId:'',
        shopId:'',
        optionsShop:[],
       
        StartDate:'',
        EndDate:'',
        logCount:0,
        dialogTableVisible:false,
        filters: {
					Name: ''
                },
                total:0,
                listLoading:false,
        dateValue: '',
        businessData:[],
        logLoading:false,
        businessDataDetail:[],
        businessDataList:[],
         pickerOptions: {
              shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
},
 methods:{
          ...mapGetters(['getuserstate']),
          getShopList()
        {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
        },                
       detail(index,row){
				this.dialogTableVisible=true;
				// this.TitleName=row.Name;
                // this.ShopId=row.Id;
                //  var data=new Date(parseInt(this.StartDate.slice(6)));
                 
               
					let Params = {
                    // StartDate:new Date(parseInt(this.businessData.StartDate.slice(6))),                   
                    // EndDate: new Date(parseInt(this.businessData.EndDate.slice(6))),
                    StartDate:this.businessData.StartDate,
                    EndDate:this.businessData.EndDate,
                    CardType:row.CardType,
                    Age:row.Serial,
                    Sex:row.Sex,
                      TenancyId:this.shopId
                   

                };			
				this.logLoading	=true;  
				  GetCustomerDetail(Params).then((res) => {
                    //前端mock测试
                    this.businessDataDetail=res.data.Data;
                    this.logCount=res.data.Data.length;
                    this.logLoading=false;
                    //  console.log(res.data.Data);
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
			//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			formatType: function (row, column) {
				return row.CardType == 0 ? '次卡' : row.CardType == 1 ? '月卡' : row.CardType == 2 ? '年卡': row.CardType == 3 ? '充值卡': row.CardType == 4 ? '培训卡': row.CardType==5?'业主卡':'未办理';
            },
 			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.CreationTime), 'yyyy-MM-dd');
			},           
    GetBusinessData(){
                 if(this.TenancyId=='0'||this.TenancyId==null)
                 {
               if(this.dateValue.length<1)
                {
                         this.$message({
							message: "请先选择时间",
							type: 'error'
                        });                   
                    return;
                }
                 }
               this.listLoading=true;
				let Params = {
                    StartDate:this.dateValue[0],
                    EndDate:this.dateValue[1],
                      TenancyId:this.shopId
                   
				};			
				// this.logLoading	=true;  
				  GetCustomerTypeReport(Params).then((res) => {
                      this.businessDataList=res.data.Data.ReportList;
                      this.businessData=res.data.Data;
                      this.StartDate=res.data.Data.StartDate;
                      this.EndDate=res.data.Data.EndDate;
                      console.log(this.businessData);
                      this.total=res.data.Data.ReportList.length;
                       this.listLoading=false;
					//前端mock测试length
                    // console.log(res.data.Data);
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },
            selsChange: function (sels) {
				this.sels = sels;
			},
    },

   	 mounted() {
    //    this.GetBusinessData();
                 this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
                                    this.getShopList();

	}

}
</script>




// WEBPACK FOOTER //
// table.vue?29010f9b